import { render, staticRenderFns } from "./projectModal.vue?vue&type=template&id=71fe7aec&scoped=true"
import script from "./projectModal.vue?vue&type=script&lang=js"
export * from "./projectModal.vue?vue&type=script&lang=js"
import style0 from "./projectModal.vue?vue&type=style&index=0&id=71fe7aec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe7aec",
  null
  
)

export default component.exports